/**
 * @file   弹奏指法
 * @create macaiqi 2025/07/04
 * @update 
 */
import React, { useEffect, useState } from 'react';
import { queryArchivesList, queryArchivesById } from '../../service';
import cls from 'classnames'
import Slider from 'react-slick';
import './index.scss'
const Content = ({ ChooseId, setChooseId }) => {
    const [contentdata, setContentdata] = useState()
    useEffect(() => {
        queryArchivesById(ChooseId).then(res => {
            setContentdata(res)
        })
    }, [ChooseId])
    return (
        <div className="common-page">
            <div className="shade animate__animated animate__fadeIn animate__fast">
                <i
                    className="close"
                    onClick={() => {
                        setChooseId()
                    }}></i>
                <div className="choose-title">
                    {contentdata?.title}
                </div>
                <div className="cont">
                    <div className="contbox" dangerouslySetInnerHTML={{ "__html": contentdata?.content }}></div>

                </div>

            </div>
        </div >

    )
}
export default function ZhiFa({ setShow }) {
    const [data, setData] = useState()
    const [data1, setData1] = useState()
    const [ChooseId, setChooseId] = useState() // 选中的详情
    const NextArrow = ({ className, style, onClick }) => (
        <div className={cls(className)} onClick={onClick} style={style} />
    );
    const PrevArrow = ({ className, style, onClick }) => (
        <div className={cls(className)} onClick={onClick} style={style} />
    );
    useEffect(() => {
        queryArchivesList({
            resource: 'YOU',
            pagination: {
                size: 0,
                page: 0
            }
        }).then(res => {
            console.log(res)
            setData(res)
        })
    }, [])
    useEffect(() => {
        queryArchivesList({
            resource: 'ZUO',
            pagination: {
                size: 0,
                page: 0
            }
        }).then(res => {
            setData1(res)
        })

    }, [])
    const settings = {
        dots: false,
        infinite: false,
        speed: 1000,
        arrow: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: <PrevArrow className="arrow prevarrow" />,
        nextArrow: <NextArrow />,
    };
    return (
        <div className='common-page zhifa-page'>
            <div className="c-title">
                手势指法
            </div>
            <div className="content">
                <div className="box">
                    <div className="list-title">
                        手势指法 右手手势图说<span>（单指指法）</span>
                    </div>
                    <div className="list">
                        <Slider {...settings}>
                            {data?.records?.map((item, index) => {
                                return (
                                    <div>
                                        <div className="item" onClick={() => {
                                            setChooseId(item.id)
                                        }}>
                                            <div className="imgbox" key={index}>
                                                <img src={window.ENV_IMG_PREURL + item.imgSrc} alt="" srcset="" />
                                            </div>
                                            <p className="t">
                                                {item.title}
                                            </p>
                                        </div>
                                    </div>


                                );
                            })}
                        </Slider>
                    </div>
                </div>
                <div className="box">
                    <div className="list-title">
                        左手手势图说<span>（单指指法）</span>
                    </div>
                    <div className="list">
                        <Slider {...settings}>
                            {data1?.records?.map((item, index) => {
                                return (
                                    <div>
                                        <div className="item" onClick={() => {
                                            setChooseId(item.id)
                                        }}>
                                            <div className="imgbox" key={index}>
                                                <img src={window.ENV_IMG_PREURL + item.imgSrc} alt="" srcset="" />
                                            </div>
                                            <p className="t">
                                                {item.title}
                                            </p>
                                        </div>
                                    </div>


                                );
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
            {ChooseId && <Content ChooseId={ChooseId} setChooseId={setChooseId} />}
            <div
                className="back"
                onClick={() => {
                    setShow();
                }}
            ></div>
        </div>
    )
}
